import { render, staticRenderFns } from "./left-button.vue?vue&type=template&id=895616c8&scoped=true&"
import script from "./left-button.vue?vue&type=script&lang=js&"
export * from "./left-button.vue?vue&type=script&lang=js&"
import style0 from "./left-button.vue?vue&type=style&index=0&id=895616c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895616c8",
  null
  
)

export default component.exports